import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col items-center gap-2 text-center" };
const _hoisted_2 = { class: "text-xl font-bold leading-6 text-(--colors-text-heading)" };
const _hoisted_3 = {
    class: "text-base leading-6 text-(--colors-text-body)",
    "data-testid": "donation-delete-blocked-reason"
};
import { computed } from "vue";
import { Modal, Button } from "@eudonet/opal";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DonationDeleteBlockedModal',
    props: {
        modelValue: { type: Boolean },
        blocker: {}
    },
    emits: ["update:modelValue", "close"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const REASON_KEYS = {
            StatusLocked: "finance.donations.deleteBlocked.reasonStatus",
            TaxReceiptLinked: "finance.donations.deleteBlocked.reasonTaxReceipt",
        };
        const reasonKey = computed(() => REASON_KEYS[props.blocker]);
        function onModelValue(value) {
            emit("update:modelValue", value);
        }
        function onClose() {
            emit("close");
            emit("update:modelValue", false);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Modal), {
                "model-value": __props.modelValue,
                size: "xs",
                dismissable: false,
                "close-on-escape": true,
                "show-header": false,
                "footer-position": "center",
                "data-testid": "donation-delete-blocked-modal",
                "onUpdate:modelValue": onModelValue,
                onClose: onClose
            }, {
                footer: _withCtx(() => [
                    _createVNode(_unref(Button), {
                        variant: "primary",
                        size: "md",
                        label: _ctx.$t('finance.donations.deleteBlocked.close'),
                        "data-testid": "donation-delete-blocked-close",
                        onClick: onClose
                    }, null, 8 /* PROPS */, ["label"])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex h-12 w-12 items-center justify-center rounded-lg border border-(--colors-border-base-medium) bg-(--colors-background-white)" }, [
                            _createElementVNode("i", {
                                class: "ri-lock-line text-2xl text-(--colors-text-error)",
                                "aria-hidden": "true"
                            })
                        ], -1 /* CACHED */)),
                        _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("finance.donations.deleteBlocked.title")), 1 /* TEXT */),
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t(reasonKey.value)), 1 /* TEXT */)
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["model-value"]));
        };
    }
});
